import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);

export const createCheckout = (payload) => axios.post(`${API}/payments/checkout`, payload);

export const getPaymentStatus = (sessionId) => axios.get(`${API}/payments/status/${sessionId}`);

export const getPayPalStatus = (orderId) => axios.get(`${API}/paypal/order/${orderId}/status`);
